export default "__VITE_ASSET__CtfdFbc0__"